export const NOTIFICATION_MESSAGES = {
    success: {
        add: (entity: string) => `${entity} aggiunto correttamente.`,
        update: (entity: string) => `${entity} modificato correttamente.`,
        delete: (entity: string) => `${entity} eliminato correttamente.`,
        generic: () => `Salvataggio avvenuto con successo.`,
        upload: (entity: string) => `Upload del file ${entity} completato con successo.`,
        import: () => `Import eseguito con successo.`,
        export: () => `Export eseguito con successo.`,
        download: (entity: string) => `Download del file ${entity} completato con successo.`,
        state: (entity: string) => `Stato del job ${entity} modificato con successo.`,
        indexing: () => `Indicizzazione eseguita con successo.`
    },
    error: {
        add: (entity: string) => `Si è verificato un errore durante l'aggiunta di ${entity}`,
        update: (entity: string) => `Si è verificato un errore durante la modifica di ${entity}`,
        delete: (entity: string) => `Si è verificato un errore durante l'eliminazione di ${entity}`,
        generic: () => `Si è verificato un errore, riprovare più tardi.`,
        upload: (entity: string) => `Errore durante il caricamento del file: ${entity}`,
        restricted: () => `Attenzione. Non si possiedono i permessi per accedere a questa sezione.`,
        autolearning: () => `Il valore di autolearning non risulta aggiornato. Riprovare più tardi.`,
        import: () => `Si è verificato un errore durante l'import. Riprovare più tardi.`,
        export: () => `Si è verificato un errore durante l'export. Riprovare più tardi.`,
        download: (entity: string) => `Errore durante il download del file: ${entity}. Riprovare più tardi.`,
        state: (entity: string) => `Errore durante la modifica dello stato del job: ${entity}.`,
        indexing: () => `Si è verificato un errore durante il processo di indicizzazione. Riprovare più tardi.`
    }
};